import './component.scss'
import 'Components/nurikae_site/pages/companies/index/partials/area_tabs/component'

import { Application, Controller } from 'stimulus'

const app = Application.start()

app.register(
  'site-companies-sticky-header',
  class extends Controller {
    static targets = ["header", "pcTrigger", "spTrigger"]

    connect() {
      this.observer = null;

      this.handleResize = this.setupObservers.bind(this);
      window.addEventListener('resize', this.handleResize);

      this.setupObservers();
    }

    disconnect() {
      if (this.observer) {
        this.observer.disconnect();
      }
      window.removeEventListener('resize', this.handleResize);
    }

    /**
     * 画面幅に応じて監視対象（トリガー）を決定し、Intersection Observerを設定する
     */
    setupObservers() {
      if (this.observer) this.observer.disconnect();

      let targetToObserve = null;

      if (this.hasSpTriggerTarget) {
        targetToObserve = this.spTriggerTarget;
      }

      if (targetToObserve) {
        const options = { root: null, rootMargin: '0px', threshold: 0 };
        this.observer = new IntersectionObserver(this.handleIntersection.bind(this), options);
        this.observer.observe(targetToObserve);
      }
    }

    /**
     * 要素が画面内外に移動したときに呼び出されるコールバック
     * @param {IntersectionObserverEntry[]} entries
     */
    handleIntersection(entries) {
      entries.forEach(entry => {
        if (!entry.isIntersecting) {
          this.showHeader();
        } else {
          this.hideHeader();
        }
      });
    }

    showHeader() {
      this.headerTarget.classList.add('companies-sticky-header--visible');
    }

    hideHeader() {
      this.headerTarget.classList.remove('companies-sticky-header--visible');
    }
  }
)
